import { render, staticRenderFns } from "./AddGenerarMovmiento.vue?vue&type=template&id=63b9666f&scoped=true&"
import script from "./AddGenerarMovmiento.vue?vue&type=script&lang=ts&"
export * from "./AddGenerarMovmiento.vue?vue&type=script&lang=ts&"
import style0 from "./AddGenerarMovmiento.vue?vue&type=style&index=0&id=63b9666f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b9666f",
  null
  
)

export default component.exports